import TYPES from '@/modules/shared/types';

// Domain
import { AllianzAccountStatementRepository } from '../../domain/repository';
import { AllianzAccountStatementEntity } from '../../domain/entities/allianz-account-statement-entity';
import { AllianzDownloadAccountStatementDto } from '../../domain/dtos/allianz-download-account-statement-dto';
import { AllianzAccountStatementDownloadedEntity } from '../../domain/entities/allianz-account-statement-downloaded-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class AllianzAccountStatementHttpRepository implements
  AllianzAccountStatementRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/allianz/account-statement/`;

  search(): Promise<Array<AllianzAccountStatementEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }

  download(download_account_statement: AllianzDownloadAccountStatementDto):
    Promise<AllianzAccountStatementDownloadedEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(`${this.endpoint}download/`, 'POST', download_account_statement)
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
